/* globals __TEST__ */
/**
 * App configuration - a mix of defaults and detected
 * environment settings.
 */
import _ from "lodash";
import defaults from "defaultConfig";
import environments from "environmentConfig";
import { getDecodedQueryParamsFromWindow } from "util/uriUtil";

function buildUri(object) {
    let uri = "";
    if (object.protocol && object.hostname) {
        uri += object.protocol + "://";
    }
    if (object.hostname) {
        uri += object.hostname;
    }
    if (object.port && object.hostname) {
        uri += ":" + object.port;
    }
    if (object.path) {
        if (!object.path.match("^/")) {
            uri += "/";
        }
        uri += object.path;
    }

    return uri;
}

let envOverride = "";

/** @type {typeof import("./defaultConfig").default} */
let envConfig = {};
let apiUri = "";
let uploadServiceUri = "";
let appVersion = "";

if (!__TEST__) {
    envOverride = getDecodedQueryParamsFromWindow().env;
    let environment = _.find(environments, (_value_, key) =>
        window.location.hostname.match(key + "$")
    );

    if (envOverride) {
        environment =
            _.find(environments, (env) => env.envName === envOverride) ||
            environment;
    }

    // Use default values if we're not in a recognized environment
    envConfig = environment
        ? Object.assign({}, defaults, environment)
        : Object.assign(
              {},
              defaults,
              environments[defaults.defaultEnvironment]
          );

    apiUri = buildUri(envConfig.api);
    uploadServiceUri = buildUri(envConfig.uploadService);
    appVersion = document
        .querySelector('head meta[name="app-version"]')
        .getAttribute("content");
} else {
    apiUri = "mockedApiUri";
    uploadServiceUri = apiUri;
}

const config = {
    envName: envConfig.envName,
    ...envConfig,
    ...{ api: { uri: apiUri } },
    ...{ uploadService: { uri: uploadServiceUri } },
    appVersion,
};

export default config;
